// ==============================|| DEFAULT THEME COLORS ||============================== //

const defaultColor = {
  // paper & background
  paper: '#ffffff',

  // primary (Teal - MYBOX Primary Interaction)
  primaryLight: '#F0FDFA',
  primary200: '#99F6E4',
  primaryMain: '#14B8A6', 
  primaryDark: '#0D9488',
  primary800: '#0F766E',

  // secondary (Orange - MYBOX Brand Accent)
  secondaryLight: '#ffedd5',
  secondary200: '#fdba74',
  secondaryMain: '#ea580c', 
  secondaryDark: '#c2410c',
  secondary800: '#9a3412',

  // success (Green - Semantic Verified / Active)
  successLight: '#F0FDF4',
  success200: '#BBF7D0',
  successMain: '#10B981',
  successDark: '#059669',

  // error (Crimson Red - Destructive / Danger)
  errorLight: '#FEF2F2',
  errorMain: '#E60023', 
  errorDark: '#B91C1C',

  // orange (PML Brand)
  orangeLight: '#ffedd5',
  orangeMain: '#ea580c',
  orangeDark: '#c2410c',

  // warning (Amber - Semantic Pending / Caution)
  warningLight: '#FFFBEB',
  warningMain: '#F59E0B',
  warningDark: '#D97706',

  // grey (Slate - Neutral Hierarchy)
  grey50: '#F8FAFC',
  grey100: '#F1F5F9',
  grey200: '#E2E8F0',
  grey300: '#CBD5E1',
  grey500: '#94A3B8',
  grey600: '#64748B',
  grey700: '#475569',
  grey900: '#1E293B',

  // ==============================|| DARK THEME VARIANTS ||============================== //

  // surfaces
  darkCanvas: '#16181D',
  darkBackground: '#16181D',
  darkSidebar: '#1B1E24',
  darkHeader: '#1B1E24',
  darkPaper: '#20242B',
  darkCard: '#20242B',
  darkRaised: '#272B33',
  darkInput: '#1A1D23',
  darkHover: '#2A2E36',

  // dark borders & dividers
  darkBorder: 'rgba(255, 255, 255, 0.08)',
  darkBorderStrong: 'rgba(255, 255, 255, 0.13)',
  darkTableRowDivider: 'rgba(255, 255, 255, 0.07)',
  darkChartGridlines: 'rgba(255, 255, 255, 0.07)',
  darkModalBackdrop: 'rgba(10, 11, 14, 0.55)',

  // dark levels (surfaces & borders compatibility)
  darkLevel1: '#1B1E24',
  darkLevel2: '#272B33',

  // text variants
  darkTextTitle: '#ECEEF1',
  darkTextPrimary: '#ECEEF1',
  darkTextSecondary: '#A4ABB8',
  darkTextPlaceholder: '#6B7280',
  darkTextDisabled: '#566070',

  // primary dark (Teal - MyBox Brand Accent)
  darkPrimaryLight: 'rgba(20, 184, 166, 0.12)',
  darkPrimaryMain: '#14B8A6',
  darkPrimaryDark: '#0D9488',
  darkPrimary200: '#2DD4BF',
  darkPrimary800: '#0F766E',

  // secondary dark (Amber - replaces orange)
  darkSecondaryLight: 'rgba(245, 176, 66, 0.12)',
  darkSecondaryMain: '#F5B042',
  darkSecondaryDark: '#D97706',
  darkSecondary200: '#FDE68A',
  darkSecondary800: '#B45309',

  // semantics dark
  darkSuccess: '#34D399',
  darkWarning: '#FBBF24',
  darkError: '#F87171',
  darkInfo: '#60A5FA'
};

export default defaultColor;
